document.querySelectorAll('.acc-Form_Form').forEach(function (form) {
  var passwordInputs = form.querySelectorAll('input[type="password"]')
  if (!passwordInputs.length) return

  var emojiPattern = /[\u{1F000}-\u{1FFFF}\u{2600}-\u{27BF}\u{2190}-\u{21FF}\u{2300}-\u{23FF}\u{25A0}-\u{25FF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}]/u
  var emojiPatternGlobal = /[\u{1F000}-\u{1FFFF}\u{2600}-\u{27BF}\u{2190}-\u{21FF}\u{2300}-\u{23FF}\u{25A0}-\u{25FF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}]/gu
  var hasUppercase = /[A-Z]/
  var hasLowercase = /[a-z]/
  var hasNumber = /[0-9]/
  var minLength = 8

  function stripEmojis (value) {
    return value.replace(emojiPatternGlobal, '')
  }

  passwordInputs.forEach(function (passwordInput) {
    passwordInput.addEventListener('input', function () {
      var stripped = stripEmojis(passwordInput.value)
      if (stripped !== passwordInput.value) {
        var cursor = passwordInput.selectionStart
        var removedCount = passwordInput.value.length - stripped.length
        passwordInput.value = stripped
        var newCursor = Math.max(0, cursor - removedCount)
        passwordInput.setSelectionRange(newCursor, newCursor)
      }
    })
  })

  function getValidationContainer () {
    var container = form.querySelector('.frm-Form_Validation[data-password-validation]')
    if (!container) {
      container = document.createElement('div')
      container.className = 'frm-Form_Validation'
      container.setAttribute('data-password-validation', '')
      container.setAttribute('autofocus', '')
      var buttons = form.querySelector('.frm-Form_Buttons')
      if (buttons) {
        form.insertBefore(container, buttons)
      } else {
        form.appendChild(container)
      }
    }
    return container
  }

  function showErrors (messages) {
    var container = getValidationContainer()
    container.innerHTML = ''

    messages.forEach(function (message) {
      var text = document.createElement('p')
      text.className = 'frm-Form_ValidationText frm-Form_ValidationText-error'
      text.textContent = message
      container.appendChild(text)
    })
  }

  function clearErrors () {
    var container = form.querySelector('.frm-Form_Validation[data-password-validation]')
    if (container) {
      container.remove()
    }
  }

  function getPasswordErrors (password) {
    var errors = []

    if (emojiPattern.test(password)) {
      errors.push('Password cannot contain emojis.')
    }

    if (password.length < minLength) {
      errors.push('Password must be at least ' + minLength + ' characters long.')
    }

    if (!hasUppercase.test(password)) {
      errors.push('Password must contain at least one uppercase letter.')
    }

    if (!hasLowercase.test(password)) {
      errors.push('Password must contain at least one lowercase letter.')
    }

    if (!hasNumber.test(password)) {
      errors.push('Password must contain at least one number.')
    }

    return errors
  }

  form.addEventListener('submit', function (event) {
    var allErrors = []
    var firstInvalidInput = null

    passwordInputs.forEach(function (passwordInput) {
      var errors = getPasswordErrors(passwordInput.value)

      if (errors.length) {
        allErrors = allErrors.concat(errors)
        passwordInput.setAttribute('aria-invalid', 'true')
        if (!firstInvalidInput) {
          firstInvalidInput = passwordInput
        }
      } else {
        passwordInput.removeAttribute('aria-invalid')
      }
    })

    if (allErrors.length) {
      event.preventDefault()
      event.stopImmediatePropagation()

      var uniqueErrors = allErrors.filter(function (message, index) {
        return allErrors.indexOf(message) === index
      })

      showErrors(uniqueErrors)
      firstInvalidInput.focus()
      return
    }

    clearErrors()
  }, true)
})
